<template>
  <div class="bg">
    <div class="box">
      <div class="window">
        <div class="window-left">
          <div class="window-left-title">养老机构服务信用评价平台</div>
          <img class="window-left-img" src="../assets/login.png" />
        </div>
        <div class="window-right">
          <div class="window-right-title login-title">修 改 密 码</div>
          <el-input class="login-input" v-model="username" :placeholder="usernameRule" />
          <el-input class="login-input" v-model="originalPassword" :placeholder="originalPasswordRule" show-password />
          <el-input class="login-input" v-model="password" :placeholder="passwordRule" show-password />
          <el-input class="login-input" v-model="password2" :placeholder="password2Rule" show-password />
          <div class="yzm" v-if="captchaEnabled">
            <el-input class="login-input yzm-input" v-model="code" :placeholder="codeRule"></el-input>
            <img id="yzmimg" :src="yzmUrl" @click="getCode" alt="验证码">
          </div>
          <el-button class="login-btn" type="primary" @click="doResetPassword" :loading="loading">
            <span v-if="!loading">确定修改</span>
            <span v-else>修改中中...</span>
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCodeImg, updatePassword } from "@/api/login";

export default {
  name: 'ResetPassword',
  data() {
    return {
      username: "",
      originalPassword: "",
      password: "",
      password2: "",
      code: "",
      usernameRule: "请输入用户名",
      originalPasswordRule: "请输入原密码",
      passwordRule: "请输入新密码",
      password2Rule: "请再次输入新密码",
      codeRule: "请输入验证码",
      yzmUrl: '',
      captchaEnabled: true,
      uuid: "",
      loading: false
    }
  },
  watch: {},
  created() {
    this.getCode();
  },
  mounted() {},
  methods: {
    // 获取验证码
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled;
        if (this.captchaEnabled) {
          this.yzmUrl = "data:image/gif;base64," + res.img;
          this.uuid = res.uuid;
        }
      });
    },
    doResetPassword() {
      if (!this.checkParams()) return
      this.loading = true;
      // 改密
      updatePassword({
        code: this.code,
        newPassword: this.password,
        password: this.originalPassword,
        username: this.username,
        uuid: this.uuid,
      }).then(() => {
        this.$message.success("密码修改成功")
        this.$router.push({ path: this.redirect || "/" }).catch(()=>{});
      }).catch(() => {
        this.loading = false;
        if (this.captchaEnabled) {
          this.getCode();
        }
      });
    },
    // 通过校验返回 true,否则返回 false
    checkParams() {
      if (!this.username) {
        this.$message.error(this.usernameRule)
        return false
      }
      if (!this.originalPassword) {
        this.$message.error(this.originalPasswordRule)
        return false
      }
      if (!this.password) {
        this.$message.error(this.passwordRule)
        return false
      }
      // 新旧密码不能一样
      if (this.password === this.originalPassword) {
        this.$message.error("新密码与原密码相同")
        return false
      }

      if (!this.password2) {
        this.$message.error(this.password2Rule)
        return false
      }
      if (this.password !== this.password2) {
        this.$message.error("两次输入的密码不一致")
        return false
      }
      if (!this.code) {
        this.$message.error(this.codeRule)
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>

.login-title {
  margin: 20px auto 60px;
}
a {
  color: rgba(255, 255, 255, 1);
}
</style>



// WEBPACK FOOTER //
// src/views/ResetPassword.vue